import React, { useEffect, useState } from "react";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Container
} from "reactstrap";
import RoleForm from "../../components/RoleForm";
import RoleTable from "../../components/RoleTable";
import RoleServices from "../../services/RoleServices";
import UserServices from "../../services/UserServices";


const Roles = () => {
    const [roles, setRoles] = useState([]);
    const [users, setUsers] = useState([]);
    const [modal, setModal] = useState(false);
    const [editingRole, setEditingRole] = useState(null);

    useEffect(() => {
        RoleServices.getRoles().then(data => {
            setRoles(data['data']);
        });
        UserServices.getUsers().then(data => {
            setUsers(data['data']);
        });
    }, []);

    const toggleModal = () => {
        setModal(!modal);
        setEditingRole(null);
    };

    const handleAddRole = (role) => {
        const newRole = {
            id: roles.length + 1,
            ...role,
            created_by: parseInt(localStorage.getItem('created_by')),
        };
        RoleServices
            .addRole({ ...role, created_by: parseInt(localStorage.getItem('created_by')) });
        setRoles([...roles, newRole]);
        toggleModal();
    };

    const handleEditRole = (role) => {
        setEditingRole(role);
        setModal(true);
    };

    const handleUpdateRole = (updatedRole) => {
        setRoles((prevRoles) =>
            prevRoles.map((role) =>
                role.id === editingRole.id ? { ...role, ...updatedRole } : role
            )
        );
        RoleServices
            .updateRole(updatedRole);
        toggleModal();
    };

    const handleDeleteRole = (roleToDelete) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer ce rôle ?')) {
            RoleServices
                .deleteRole(roleToDelete);
            setRoles((prevRoles) => prevRoles.filter((role) => role.id !== roleToDelete.id));
        } else {
            return;
        }
    };

    return (
        <Container>
            <h1 className="mb-5">Rôles</h1>
            <Button color="primary" onClick={toggleModal}>
                Add Role
            </Button>
            <RoleTable roles={roles} onEdit={handleEditRole} onDelete={handleDeleteRole} users={users} />
            <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>{editingRole ? "Edit Role" : "Add Role"}</ModalHeader>
                <ModalBody>
                    <RoleForm
                        role={editingRole || { title: "", status: "", overview: " " }}
                        onSubmit={editingRole ? handleUpdateRole : handleAddRole}
                        onCancel={toggleModal}
                    />
                </ModalBody>
            </Modal>
        </Container>
    );
};

export default Roles;